import React from 'react';
import { motion } from 'framer-motion';

const AboutUs = () => {
  const fontStyle = { fontFamily: '"Poetsen One", sans-serif', fontWeight: 'normal' };

  const fadeInUp = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
    viewport: { once: true }
  };

  const zoomIn = {
    initial: { scale: 0.8, opacity: 0 },
    whileInView: { scale: 1, opacity: 1 },
    transition: { duration: 0.5 },
    viewport: { once: true }
  };

  return (
    <div
      style={{
        backgroundImage: 'url("https://res.cloudinary.com/dwf8ifbzs/image/upload/v1744277433/jmills_walpaper_2_wme9a7.jpg")',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}
    >
      <section className="px-4 sm:px-6 md:px-12 lg:px-32 py-10 mt-8 bg-white/80 backdrop-blur-sm" style={fontStyle}>
        <motion.h2
          className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold leading-tight bg-gradient-to-r from-green-600 to-yellow-400 bg-clip-text text-transparent text-center mt-4"
          style={fontStyle}
          {...fadeInUp}
        >
          About Us
        </motion.h2>

        <motion.p
          className="text-base sm:text-lg md:text-xl text-center mb-8 mt-4"
          style={fontStyle}
          {...fadeInUp}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          A Legacy of Purity and Excellence Since 1998
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-12">
          <motion.div
            className="p-2 md:p-4 flex flex-col justify-center text-justify"
            {...fadeInUp}
          >
            <motion.p className="text-sm sm:text-base md:text-lg mb-4" style={fontStyle} {...fadeInUp}>
              At Jayamal Oil Mills, our story is one of dedication, trust, and excellence. Established in 1998 as a family business, we began our journey with a copra production unit—Copra Massa (කොප්පරා මැස්ස), laying the foundation for our deep-rooted expertise in coconut processing. With an unwavering commitment to quality, we took a significant step forward in 2010, expanding our operations to include our own coconut oil production facility.
            </motion.p>
            <motion.p className="text-sm sm:text-base md:text-lg" style={fontStyle} {...fadeInUp} transition={{ delay: 0.1 }}>
              For over two decades, our journey has been built on customer trust, ensuring that every product we create reflects purity, authenticity, and tradition. From sourcing the finest coconuts to using advanced yet natural processing methods, we guarantee 100% pure, chemical-free, and sustainably produced coconut oil and coconut-based products.
            </motion.p>
          </motion.div>

          <motion.div className="p-2 md:p-4 flex justify-center" {...zoomIn}>
            <motion.img
              src="https://img1.exportersindia.com/product_images/bc-full/dir_165/4942862/milling-copra-1498138964-3082097.jpeg"
              alt="Coconut Processing"
              className="w-full max-w-md sm:max-w-lg md:max-w-full h-auto"
              {...zoomIn}
            />
          </motion.div>
        </div>

        <div className="mt-10 mb-10 px-4 md:px-8">

        {/* Certified Section */}
          <motion.div
            className="pt-12 pb-8 px-4 sm:px-6 lg:px-20 mb-10"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="bg-green-100 border-l-4 border-green-700 p-6 rounded-lg shadow">
              <h2 className="text-2xl font-bold text-green-800 mb-2">Certified & Compliant</h2>
              <p className="text-green-900 text-lg">
                We are officially registered under the Coconut Development Authority of Sri Lanka, 
                reflecting our commitment to quality, authenticity, and ethical production practices.
                <br />
                
              </p>
            </div>
          </motion.div>
          {/* Certifications & Quality Compliance Section */}
          <motion.div
            className="mb-12 px-6 sm:px-12 py-10 bg-white/70 backdrop-blur-md"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-center text-green-800" style={fontStyle}>
              Certifications & Quality Compliance
            </h2>

            <p className="text-sm sm:text-base md:text-lg text-justify mb-10" style={fontStyle}>
              At <strong>Jayamal Copra and Oil Manufacturer</strong>, quality, safety, and compliance are integral to our manufacturing philosophy. 
              Our processes are designed and maintained in accordance with nationally recognized standards to ensure product safety, consistency, and customer trust.
            </p>

            {/* Certification Details */}
            <div className="flex flex-col md:flex-row md:items-center gap-8 md:gap-12 mb-6">
            {/* Logo Section */}
              <div className="md:w-1/2 flex justify-center items-center">
                <img
                  src="/images/logo.png"
                  alt="GMP Certification Logo"
                  className="max-w-xs sm:max-w-sm md:max-w-md w-full h-auto object-contain"
                />
              </div>
              {/* Text Section */}
              <div className="md:w-1/2">
                <h3 className="text-2xl font-semibold text-green-700 mb-4" style={fontStyle}>
                  Good Manufacturing Practices (GMP) Certification
                </h3>
                <ul className="list-disc pl-6 text-sm sm:text-base md:text-lg text-green-900" style={fontStyle}>
                  <li><strong>Certification Body:</strong> Ceycert (Pvt) Ltd</li>
                  <li><strong>Standard:</strong> Good Manufacturing Practices (GMP)</li>
                  <li><strong>Scope:</strong> Manufacturing of Coconut Oil</li>
                </ul>
                <p className="mt-4 text-sm sm:text-base md:text-lg text-green-900" style={fontStyle}>
                  This certification confirms that our manufacturing facility operates in compliance with GMP requirements, 
                  ensuring hygienic processing, controlled operations, and continuous quality improvement.
                </p>
              </div>

              
            </div>

            {/* Disclaimer */}
            <p className="text-xs sm:text-sm md:text-base text-gray-600 italic text-center mt-6" style={fontStyle}>
              Certification applies to the manufacturing system and approved product scope and does not imply endorsement of individual products beyond certified conditions.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[{
              title: 'Our Vision',
              content: `To be a globally recognized brand that delivers high-quality, sustainable, and health-enhancing coconut-based products while empowering local communities and promoting eco-friendly practices.`
            }, {
              title: 'Our Mission',
              content: `To build a brand that reflects authenticity, health-conscious living, and customer satisfaction.`
            }].map((item, i) => (
              <motion.div
                key={i}
                className="border-4 border-brown-600 p-4 md:p-6 rounded-lg text-center md:text-left"
                {...fadeInUp}
                transition={{ delay: i * 0.2 }}
              >
                <h3 className="text-2xl sm:text-3xl font-semibold mb-4" style={fontStyle}>
                  {item.title}
                </h3>
                <p className="text-sm sm:text-base md:text-lg text-justify" style={fontStyle}>
                  {item.content}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
        {/* Add the Image Section */}
        <motion.div
          className=""
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex justify-center">
            <img
              src="https://png.pngtree.com/png-vector/20240731/ourmid/pngtree-coconut-with-splash-oil-isolated-on-white-background-image-png-image_13316580.png"
              alt="Oil Splash"
              className="w-2/3 sm:w-1/2 lg:w-1/3 h-auto object-contain"
            />
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default AboutUs;